import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import React, { useEffect, useRef, useState } from "react";
import { BillableService } from "../../../services/billable-servise";
import './billable.css'
import { Toast } from 'primereact/toast';
import { Api } from "../../../services/api";
import { Dropdown } from "primereact/dropdown";
const BillableYear = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [billableList, setBillableList] = useState([]);

    const [billableColumnList, setBillableColumnList] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const cities = [
        { name: '2021', value: '2021' },
        { name: '2022', value: '2022' },
        { name: '2023', value: '2023' },
        { name: '2024', value: '2024' },
        { name: '2025', value: '2025' },
        { name: '2026', value: '2026' },
        { name: '2027', value: '2027' },
        { name: '2028', value: '2028' },
    
        // Add more cities as needed
      ];

    const toast = useRef(null);
    useEffect(() => {
        // getBiliableData();
        getBiliableArchiveDataByYear(new Date().getFullYear());

    }, []);

    const getBiliableArchiveDataByYear = (year) => {
        console.log('getBiliableArchiveDataByYear')
        setIsLoading(true);
        var _body = {
            year: year

        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };


        fetch(Api.API_BASE_URL + 'billable-pay-periods-by-year', {

            method: "POST",
            headers:headers,

            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {

                if (response.error !== '') {
                } else {

                    var data = response.result;
                    var x = BillableService.getDataBilible(data);
                    setBillableList(x);

                }

                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
        var t = BillableService.getBillableColumnData();
        setBillableColumnList(t);

    }



    const rowClass = (data) => {
        return {
            'bg-yellow-200': data.division === 'Total Field Operations' || data.division === 'Total Pre Con Estimating' || data.division === 'Total Interior Design' || data.division === 'Total Project Management' || data.division === 'Gross Pofit/Loss' || data.division === 'Total Property Management' || data.division === 'Total Sales & Marketing' || data.division === 'Total Administration' || data.division === 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' || data.division === 'Gross Pofit/Loss Administration',
            'bg-yellow-300': data.division === 'Total Field ops/ID/PM/Pre Con' || data.division === 'Builderplaybook Gross Pofit/Loss' || data.division === 'Gross Profit/Loss' || data.division === 'Total labour burden billable vs unbillalbe Gross Profit or Loss'
        };
    };


    const headerTemplate = (data) => {
        var newStr = data.billableType;
        newStr = newStr.substring(1);
        return (

            <React.Fragment>
                <th colSpan="1" className="no-horizontal-scroll p-frozen-column myheader" style={{ border: 'none' }}>
                    <span className="flex m-3"

                        style={{ overflowX: "hidden", whiteSpace: "nowrap" }}>
                        {newStr}
                    </span>
                </th>
            </React.Fragment>
        );
    };
    const renderBodyTemplate = (col, value) => {
        if (col === 'mark_up_per' || col === 'unBillableTimePer') {
            return <span>{value.toFixed(1)}%</span>;
        }
        if (col === 'billableTime' || col === 'unBillableTime' || col === 'vacatiomStatTime' || col === 'eosTime' || col === 'salesTime' || col === 'sickTime' || col === 'totalHours') {
            if (value <= 0) {
                return <div >{value.toFixed(2)}</div>;

            } else {
                return <div>{value.toFixed(2)}</div>;
                // return <div className="bg-pink-100">{value.toFixed(2)}</div>;
            }

        }
        const isNegative = value < 0;
        return <span style={{ color: isNegative ? "red" : "black" }}>{formatCurrency(value)}</span>;
    };
    const formatCurrency = (value) => {


        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    const customItemTemplate = (option) => (
        <div style={{ padding: '8px' }}>
          {option.name}
        </div>
      );
      const onYearChange = (e) => {
        setSelectedYear(e.value);// Update selected year state when a year is chosen
        getBiliableArchiveDataByYear(e.value)
      };


    return (
        <>
            <Toast ref={toast} />
            {/* Data Table  */}
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (
                <div className="" >
                    <div className="row p-2">
                        <div className="col-3">
                            <h4 className="text-center">Pay Period Date</h4>
                        </div>
                        <div className="col-2">
                            <h4 className="text-center" style={{ color: "grey", fontWeight: 'normal' }}>ANNUAL</h4>
                        </div>
                        <div className="col" style={{ textAlign: "end",}}>
                            <Dropdown inputId="year" options={cities} optionLabel="name" className="w-full md:w-6rem  " style={{ height: '40px', padding: '8px', }} itemTemplate={customItemTemplate} value={selectedYear} onChange={onYearChange} />
                        </div>
                    </div>

                    <div className='dataTableContainer'>
                        <DataTable value={billableList} rowClassName={rowClass} stripedRows showGridlines size="large" rowGroupMode="subheader" groupRowsBy="billableType" rowGroupHeaderTemplate={headerTemplate}
                            sortMode="single" tableStyle={{ minWidth: '50rem', width: 'auto', borderCollapse: 'separate', borderSpacing: '0' }} sortField="billableType" sortOrder={1} scrollable scrollHeight="80vh" selectionMode="single"
                        >
                            {billableColumnList.map((col, i) => (
                                <Column
                                    field={col.value}
                                    frozen={i === 0 || i === 1}
                                    key={col.value}
                                    body={(e) => renderBodyTemplate(col.value, e[col.value])}

                                    header={col.name}
                                    bodyClassName={(rowData) => col.value == 'billableTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'unBillableTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'vacatiomStatTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'eosTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'salesTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'sickTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' || col.value == 'totalHours' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'Builderplaybook Gross Pofit/Loss' ? 'archivee-text' : ''}
                                    style={i === 1 ? { borderRight: '2px solid black', textAlign: 'left', minWidth: '200px', padding: "7px" } : i === 0 ? { minWidth: '300px', textAlign: 'left', padding: "7px" } : { minWidth: '150px', textAlign: 'center', }} >
                                </Column>
                            ))}
                        </DataTable>



                    </div>
                </div>
            )}



        </>
    )

}
export default BillableYear